<template>
  <router-link class="text-decoration-none router" :to="'/producto/' + this.producto.id">
    <!-- {{this.producto}} -->
    <div class="noticia-card-home">
      <div class="image-wrapper">
        <img :src="producto.image" class="img-noti" alt="product image" />
        <div v-if="producto.discount > 0" class="descuento d-flex">
          <i class="fa-solid fa-tag"></i>
          <div  class="descuento-texto">&nbsp;&nbsp;{{Math.round(this.producto.discount)}}% de descuento</div>
        </div>
      </div>
      <div class="content">
        <h2 class="title">{{ this.producto.name }}</h2>

        <div class="vistas">
          <div class="vistas-icono">
            <i class="fa-solid fa-eye"></i>
          </div>
          <div class="vistas-texto">&nbsp;{{this.producto.views}} vistas</div>

        </div>


        <div class="disponibilidad">
          
          <div v-if="producto.stock > 0" class="disponible diponibilidad-producto">
            <p>Disponible</p>
          </div>
          <div v-else-if="producto.stock == 0 && producto.coming_soon == true" class="reserva diponibilidad-producto">
            <p>¡Llega pronto!</p>
            <p>Reserva tu producto</p>
          </div>
          <div v-else-if="producto.stock == 0" class="vendido diponibilidad-producto">
            <p>Vendido</p>
          </div>

        </div>
        <p v-if="producto.discount" class="precio">{{ this.formatoNumero( this.producto.price - this.producto.price * (this.producto.discount/100)) }} {{this.moneda}}</p>
        <p v-else class="precio">{{ this.formatoNumero(this.producto.price) }} lps</p>
        <p v-if="producto.discount > 0" class="precio-anterior">{{ this.formatoNumero(this.producto.price) }} {{this.moneda}}</p>   
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: "NoticiaCardHome",
  data() {
    return {
      moneda: "lps",
    };
  },
  props: {
    producto: {
      type: Object,
      required: true,
    },
  },
  methods:{
    formatoNumero(numero) {
            return new Intl.NumberFormat("en-US").format(numero)
        },
  },
  computed: {
    computedImageSrc() {
      return require(`@/assets/products/${this.imageSrc}`);
    },
  },
};
</script>

<style scoped>
.noticia-card-home {
  margin: 20px;
  width: 280px;
  height: 440px;
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s ease-in-out;
  cursor: pointer;
  /* height: 420px; */
}

.noticia-card-home:hover {
  transform: translateY(-5px);
}

.image-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  padding: 16px;
  background-color: #f2f4f7;
  position: relative;
}

.img-noti {
  max-height: 200px;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.image-wrapper:hover .img-noti {
  transform: scale(1.05);
}

.content {
  padding: 16px;
  /* text-align: center; */
}


.title {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70px;
  font-size: 14px;
  color: #222;
  margin-bottom: 8px;
  margin-top: 3px;
}






.router {
  text-decoration: none;
  color: inherit;
}


</style>

<style>

.precio-anterior {
  font-size: 13px;
  color: #999;
  text-decoration: line-through;
  margin-bottom: 8px;
}

.vistas {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 8px;
  font-size: 13px;
}



.descuento {
  color: #ffffff;
  background-color: #CC0C39;
  width: 50%;
  border-radius: 5px;
  padding: 5px;
  font-size: 11px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 92%;
  left: 50%;
}
.disponibilidad {
  display: flex;
  justify-content: center;
  align-items: center;
  /* margin-bottom: 8px; */
}

.diponibilidad-producto{
  font-size: 13px;
  color: #ffffff;
  background-color: #8a8a8a;
  width: 40%;
  border-radius: 5px;
  margin-bottom: 8px;
}

.disponible {
  background-color: #4CAF50;
}

.vendido {
  background-color: #e6bb00;
}

.reserva {
  background-color: #0a64ff;
  width: 60%;

}
</style>